import { useCallback, useState } from 'react';

export const useRange = () => {
  const [range, setRange] = useState({ x: [], y: [] });
  const [modalRange, setModalRange] = useState({ x: [], y: [] });

  const resetRange = useCallback(() => {
    setRange({ x: [], y: [] });
    setModalRange({ x: [], y: [] });
  }, []);

  return [range, setRange, modalRange, setModalRange, resetRange];
};
